import { Component, Vue } from 'vue-facing-decorator';
import { ArrowRight } from '@element-plus/icons-vue';
import AuthService from '@/services/AuthService';

@Component(
{
    props:
    {
        breadcrumbs:
        {
            type: Array,
            required: true
        }
    },
    components:
    {
    },
})

export default class Breadcrumbs extends Vue 
{
    private Arrow : any;
    private isLoading : boolean = true;
    private showBreadcrumbs : boolean = false;
    //private entries : object[] = [] as object[];

    public async mounted()
    {
        this.Arrow = ArrowRight;
        this.showBreadcrumbs = true;

        //this.entries = this.$router.currentRoute.value.path.substr(1).split('/');

        this.isLoading = false;
    }

    public async onCrumbSelect(index : number)
    {
        if (this.breadcrumbs[index])
        {
            if (this.breadcrumbs[index][1])
            {
                this.$router.push(`${this.breadcrumbs[index][1]}`)
            }
        }
    }
}
